<template>
  <div class="map-wrapper">
    <vendors-map :map-data="validMapData" :city-zone="cityZone" :t="t" :clusterPath="clusterPath">
      <div class="vd-VendorsMap_SelectedVendor">
        <p class="h5 mb-2">{{ activeVendor.name }}</p>
        <div>
          <action-button :href="activeVendor.path" variant="small">
            {{ t.change_to_resource }}
          </action-button>
        </div>
      </div>
    </vendors-map>
    <div class="input-container">
      <div class="input-inner">
        <autocomplete
          :suggestions="validMapData"
          :placeholder="t.input_placeholder"
          @select="handleSelect"
          @input="handleChange"
          :getSuggestionValue="getSuggestionValue"
          :filteredSuggestions="filteredSuggestions"
          identifier="map-search"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VendorsMap from "./VendorsMap";
import Autocomplete from "./Autocomplete";
import ActionButton from "./ActionButton";

export default {
  name: "StoreVendorsMap",
  components: {
    VendorsMap,
    Autocomplete,
    ActionButton,
  },
  props: {
    mapData: {
      type: Array,
      required: true,
    },
    cityZone: {
      type: Object,
      default: undefined,
    },
    clusterPath: {
      type: String,
      required: true,
    },
    t: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentValue: "",
    };
  },
  computed: {
    ...mapGetters({
      activeVendor: "vendorsIndex/activeVendor",
    }),
    validMapData() {
      return this.mapData.filter(entry => !isNaN(entry.lat) && !isNaN(entry.lng));
    },
    filteredSuggestions() {
      return [
        {
          data: this.validMapData.filter(vendor => {
            return vendor.name.toLowerCase().includes(this.currentValue.toLowerCase());
          }),
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      setActiveVendor: "vendorsIndex/setActiveVendor",
    }),
    handleSelect(suggestion) {
      this.setActiveVendor(suggestion.item);
    },
    handleChange(value) {
      this.currentValue = value;
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.map-wrapper {
  position: relative;
  height: 100%;
}

.input-container {
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: $spacer-3;
  padding-top: $spacer-4;
  z-index: $zi-high;
  margin: auto;
  max-width: 500px;
}

.input-inner {
  pointer-events: all;
  width: 100%;
}

.vd-VendorsMap_SelectedVendor {
  background: $white;
  padding: $spacer-3;
  border-radius: $border-radius;
  pointer-events: auto;
  text-align: center;
  box-shadow: $box-shadow-sm;
  border: $width-border-thin solid $gray-300;
}
</style>
